import baseUrl from "../../../../baseUrl";
import {useForm} from "../../../../hooks/useForm";
import {useEffect} from "react";
import {requester} from "../../../../services/requester";
import {useCloseForm} from "../useCloseForm";

const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const CompanyNew = ({companyData, onCompanySubmit}) => {

    const request = requester();
    const closeForm = useCloseForm();
    const {values: edit_values, changeHandler: changeEditData, onSubmitEditValues} = useForm({
        company_name: companyData.company_name,
        accountable_person: companyData.accountable_person,
        address: companyData.address,
        city: companyData.city,
        phone: companyData.phone,
        company_note: companyData.company_note,
    });

    useEffect(() => {
        window.scroll({
            top: document.body.offsetHeight,
            left: 0,
            behavior: 'smooth',
        });
    }, [])

    useEffect(() => {
        onSubmitEditValues({
            company_name: companyData.company_name,
            accountable_person: companyData.accountable_person,
            address: companyData.address,
            city: companyData.city,
            phone: companyData.phone,
            company_note: companyData.company_note,
        })
    }, [companyData])

    const onSubmitEditData = async (e) => {
        e.preventDefault();

        const body = {
            bullstat: Number(companyData.bullstat),
            company_name: edit_values.company_name,
            accountable_person: edit_values.accountable_person,
            address: edit_values.address,
            city: edit_values.city,
            phone: edit_values.phone,
            company_note: edit_values.company_note,
        };

        try {
            await request.put(`${baseUrl()}/companies/${companyData.bullstat}`, body);
            onCompanySubmit();
            alert("Ползвателя е успешно редактиран!");
            closeForm();                     // Р2: обратно най-горе
        } catch (error) {
            alert(error.message || 'Възникна грешка при заявката.');
        }
    }


    return (
        <div>
            <div className="row g-3 align-items-center mb-2">
                <div className="col-2">
                    <label className="col-form-label" style={{fontWeight: "bold"}}>Ползвател</label>
                </div>
                <div className="col-6" style={{marginLeft: "10px"}}>
                    {companyData.company_name}, {companyData.bullstat}
                </div>
            </div>
            {companyData.updated_at && (
                <div className="row g-3 align-items-center mb-2">
                    <div className="col-2">
                        <label className="col-form-label" style={{fontStyle: "italic", color: "var(--app-muted)"}}>Последна промяна</label>
                    </div>
                    <div className="col-6" style={{marginLeft: "10px", fontStyle: "italic", color: "var(--app-muted)"}}>
                        {formatDate(companyData.updated_at)}
                    </div>
                </div>
            )}
            <hr/>
            <form onSubmit={onSubmitEditData}>
                <div className="row g-3 align-items-center">
                    <div className="col-2">
                        <label htmlFor="company_name" className="col-form-label">Фирма</label>
                    </div>
                    <div className="col-6" style={{marginLeft: "10px"}}>
                        <input className="col-11" id="company_name" type="text" name="company_name"
                               placeholder="Име на ползвателя"
                               value={edit_values.company_name}
                               onChange={changeEditData}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center">
                    <div className="col-2">
                        <label htmlFor="accountable_person" className="col-form-label">Лице за контакт</label>
                    </div>
                    <div className="col-6" style={{marginLeft: "10px"}}>
                        <input className="col-11" id="accountable_person" type="text" name="accountable_person"
                               placeholder="Лице за контакт"
                               value={edit_values.accountable_person}
                               onChange={changeEditData}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center">
                    <div className="col-2">
                        <label htmlFor="address" className="col-form-label">Адрес</label>
                    </div>
                    <div className="col-6" style={{marginLeft: "10px"}}>
                        <input className="col-11" id="address" type="text" name="address"
                               placeholder="Адрес"
                               value={edit_values.address}
                               onChange={changeEditData}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center">
                    <div className="col-2">
                        <label htmlFor="city" className="col-form-label">Град</label>
                    </div>
                    <div className="col-6" style={{marginLeft: "10px"}}>
                        <input className="col-11" id="city" type="text" name="city"
                               placeholder="Град"
                               value={edit_values.city}
                               onChange={changeEditData}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center">
                    <div className="col-2">
                        <label htmlFor="phone" className="col-form-label">Телефон</label>
                    </div>
                    <div className="col-6" style={{marginLeft: "10px"}}>
                        <input className="col-11" id="phone" type="text" name="phone"
                               placeholder="Телефон"
                               value={edit_values.phone}
                               onChange={changeEditData}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center">
                    <div className="col-2">
                        <label htmlFor="company_note" className="col-form-label">Забележка</label>
                    </div>
                    <div className="col-6" style={{marginLeft: "10px"}}>
                        <input className="col-11" id="company_note" type="text" name="company_note"
                               placeholder="Забележка"
                               value={edit_values.company_note}
                               onChange={changeEditData}
                        />
                    </div>
                </div>

                <button type="submit" className="btn btn-primary mt-3">Редактирай</button>
            </form>
        </div>
    );
};